package com.karawek.core.auth.usecase

import com.karawek.core.auth.api.Authenticator
import com.karawek.core.auth.model.AuthenticationInfo
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Inject
@SingleIn(AppScope::class)
class AuthenticateWithNativeUseCase(
    private val authenticator: Authenticator,
) {
    suspend operator fun invoke(): Result<AuthenticationInfo> {
        return authenticator.authenticateWithNative()
    }
}
